// extracted by mini-css-extract-plugin
export default {"embeddedPageView":"SupportChatPage_embeddedPageView__jy6GZ","embeddedPage":"SupportChatPage_embeddedPage__A+rwi"};